module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_8_D_1.ea720753.mp3";